import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    font-family: ${theme.v2.font.family.primary};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 100%;
    }
  `}
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 32px;
  justify-content: center;
  margin-top: auto;
  padding-top: 16px;
`;

export const WrapperForm = styled.div`
  ${({ theme }) => css`
    padding: 56px 20px 32px;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      padding: 40px;
      width: 560px;
    }
  `}
`;

export const WrapperImage = styled.div`
  align-items: center;
  background: #E7F3FD;
  border-radius: 0 8px 8px 0;
  display: flex;
  justify-content: flex-end;
  width: 400px;

  img {
    max-width: 384px;
  }
`;

export const Title = styled.div`
  ${({ theme, isProPlan }) => {
    const gradientFree = 'linear-gradient(274.91deg, #0070D1 71.5%, #0070D1 73.27%, #0271D2 75.03%, #0473D3 76.8%, #0775D4 78.56%, #0B78D5 80.32%, #107BD7 82.09%, #1680DA 83.85%, #1D84DD 85.61%, #258AE0 87.38%, #2D90E3 89.14%, #3796E7 90.91%, #419EEB 92.67%, #4DA5EF 94.43%, #59AEF4 96.2%, #66B7F9 97.96%, #74C1FF 99.72%)';
    const gradientPro = 'linear-gradient(93.51deg, #2E93EE 1.9%, #2E93EE 5.89%, #415ACA 40.83%, #5421A5 77.87%, #551CA2 83%, #2E1451 116.37%)';
    const gradient = isProPlan ? gradientPro : gradientFree;

    return css`
      background: ${gradient};
      font-size: ${theme.v2.font.sizes.sm2};
      font-weight: 500;
      line-height: 1.3;
      max-width: 90%;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      @media (min-width: ${theme.v2.breakpoints.md}) {
        font-size: ${theme.v2.font.sizes.md};
        max-width: 90%;
      }
    `;
  }}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 1.3;
  `}
`;

export const WrapperList = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-height: calc(100vh - 265px);
      overflow: hidden auto;
    }
  `}
`;

export const Step = styled.div`
  ${({ theme, step }) => css`
    display: flex;
    flex-direction: column;
    min-height: calc(100% - 56px);
    position: relative;

    ${step === 'step-3' && css`
      align-items: center;
      gap: 16px;
      justify-content: center;
      margin: 56px 0;
      width: 100%;
    `}

    ${step !== 'step-3' && css`
      gap: ${step === 'step-2' ? '16px' : '56px'};
      padding-top: ${step === 'step-1' ? '16px' : '30px'};

      @media (min-width: ${theme.v2.breakpoints.md}) {
        gap: ${step === 'step-2' ? '16px' : '40px'};
        padding-top: ${step === 'step-1' ? '24px' : '48px'};
      }
    `}

    @media (min-width: ${theme.v2.breakpoints.md}) { 
      min-height: 593px;
    }
  `}
`;

export const Row = styled.div`
  ${({ variant }) => css`
    display: flex;
    flex-direction: ${variant === 'column' ? 'column' : 'row'};
    gap: 16px;
  `}
`;

export const FormField = styled.div`
  position: relative;
`;

export const TextError = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowLight};
    font-size: ${theme.v2.font.sizes.sm};
    line-height: 1.5;
    text-align: center;
  `}
`;

export const WrapperButtonError = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 16px;
`;
